export enum RootPath {
  Manager = 'manager',
}

export enum AuthPath {
  Login = 'login',
  Register = 'register',
  Restore = 'restore',
}

export enum ManagerPath {
  Cabinet = 'cabinet',
  Dashboard = 'dashboard',
  QrCodes = 'qr-codes',
  Reviews = 'reviews',
  Trees = 'trees',
  Menu = 'menu',
  Lead = 'lead',
  Promotion = 'promotion',
  Form = 'form',
  Auth = 'auth',
  Devices = 'devices',
  Tasks = 'tasks',
  Staff = 'staff',
  Monitoring = 'monitoring',
  Notifications = 'notifications',
}

export enum MonitoringScopePath {
  MonitoringScope = 'monitoring-scope',
  ReviewSources = 'review-sources',
  ExternalReviews = 'external-reviews',
}
export enum NotificationsPath {
  All = 'all',
  Reviews = 'reviews',
  Staff = 'staff',
}

export enum StaffPath {
  Employees = 'employees',
  EmployeeProfile = 'employee-profile',
  CheckInCheckOut = 'check-in-check-out',
  Shifts = 'shifts',
  ShiftsImport = 'shifts-import',
  Statements = 'statements',
  RolesDictionary = 'roles-dictionary',
}

export enum MonitoringPath {
  Dashboard = 'dashboard',
  Mentions = 'mentions',
  Settings = 'settings',
}

export enum DashboardPath {
  Menu = 'menu',
  Tasks = 'tasks',
  Reviews = 'reviews',
  Staff = 'staff',
  Qr = 'qr',
  ExternalMonitoring = 'external-monitoring',
}

export enum CabinetPath {
  CompanySettings = 'company-settings',
  Branches = 'branches',
  App = 'app',
  RolesAndAccess = 'roles-and-access',
}

export enum ProfilePath {
  Personal = 'personal',
  Security = 'security',
  Socials = 'socials',
  Settings = 'settings',
}

export enum QrCodesPath {
  CreateStatic = 'create-static',
  EditStatic = 'edit-static',
  StaticList = 'static-list',
}

export enum FeedbacksPath {
  List = 'feedback-list',
  ReviewsOfBranches = 'reviews-of-branches',
}

export enum TreesPath {
  CreateTree = 'create-tree',
  EditTree = 'edit-tree',
  ListTree = 'tree-list',
}

export enum TasksPath {
  CreateTask = 'create-task',
  EditTask = 'edit-task',
  Order = 'order',
  Action = 'action',
  Common = 'common',
  Planner = 'planner',
}

export enum MenuPath {
  Informer = 'informer',
  Iiko = 'iiko',
  Rkeeper = 'rkeeper',
}

export enum InformerPath {
  CreateDish = 'create-dish',
  EditDish = 'edit-dish',
  DishList = 'dish-list',
  SectionList = 'section-list',
  CategoryList = 'category-list',
  CreateMenu = 'create-menu',
  EditMenu = 'edit-menu',
  List = 'list',
  Import = 'import',
}

export enum LeadesPath {
  List = 'list',
  Config = 'config',
}

export enum PromotionPath {
  Create = 'create',
  Edit = 'edit',
  List = 'list',
}

export enum FormPath {
  Create = 'create',
  List = 'list',
}

export enum DevicesPath {
  List = 'list',
  Create = 'create',
  Edit = 'edit',
}

export enum ReviewsPath {
  Branch = 'branch',
  Order = 'order',
  Action = 'action',
}
